export { default as FilterSolidIcon } from './FilterSolidIcon';
